<template>
    <div>
        <content-view v-show="$utils.renderWhen(this,'materielManage')">
            <!-- 物料管理 -->
            <div slot="header">
                <a-form :form="filterForm1" layout="inline" class="store-one-form" v-show="tabKey === 0">
                    <a-form-item label="物料编码">
                        <a-input style="width:100%;" placeholder="请输入" v-decorator="['goodsNo']" @pressEnter="kingDiskSearch"></a-input>
                    </a-form-item>
                    <a-form-item label="物料名称">
                        <a-input placeholder="请输入" v-decorator="['goodsName']" @pressEnter="kingDiskSearch"></a-input>
                    </a-form-item>
                    <a-form-item label="物料分组">
                        <a-input placeholder="请输入" v-decorator="['goodsGroup']" @pressEnter="kingDiskSearch"></a-input>
                    </a-form-item>
                    <a-form-item label="物料属性">
                        <a-input placeholder="请输入" v-decorator="['goodsType']" @pressEnter="kingDiskSearch"></a-input>
                    </a-form-item>
                    <a-form-item label="物料条形码">
                        <a-input placeholder="请输入" v-decorator="['goodsBarCode']" @pressEnter="kingDiskSearch"></a-input>
                    </a-form-item>
                    <a-form-item label="所在仓库名称">
                        <a-input placeholder="请输入" v-decorator="['warehouseName']" @pressEnter="kingDiskSearch"></a-input>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button type="primary" @click="kingDiskSearch" :loading="kingDiskSearchLoading">筛选</a-button>
                        <a-button @click="kingDiskHandleReset" :loading="kingDiskSearchLoading">重置</a-button>
                    </a-form-item>
                </a-form>
                <a-form :form="filterForm2" layout="inline" class="store-one-form" v-show="tabKey === 1">
                    <a-form-item label="商品编号">
                        <a-input style="width:100%;" placeholder="请输入" v-decorator="['goodsNo']" @pressEnter="selfSearch"></a-input>
                    </a-form-item>
                    <a-form-item label="商品条形码">
                        <a-input placeholder="请输入" v-decorator="['goodsBarCode']" @pressEnter="selfSearch"></a-input>
                    </a-form-item>
                    <a-form-item label="商品名称">
                        <a-input placeholder="请输入" v-decorator="['goodsName']" @pressEnter="selfSearch"></a-input>
                    </a-form-item>
                    <a-form-item label="商品分组">
                        <a-select :options="typeOptions" placeholder="请输入" v-decorator="['goodsCategoryId']" @select="selfSearch"></a-select>
                    </a-form-item>
                    <a-form-item label="所在仓库名称">
                        <a-input placeholder="请输入" v-decorator="['warehouseName']" @pressEnter="selfSearch"></a-input>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button type="primary" @click="selfSearch" :loading="selfSearchLoading">筛选</a-button>
                        <a-button @click="selfHandleReset" :loading="selfSearchLoading">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-tabs type="card" class="tabs-bar-no-margin" v-model="tabKey">
                <template slot="tabBarExtraContent">
                    <div v-show="tabKey === 0">
                        <a-button type="primary" @click="kingDiskGoodsRefresh" :loading="kingDiskGoodsRefreshLoading">数据刷新</a-button>
                    </div>
                    <div v-show="tabKey === 1">
                        <a-button v-if="getBtnByAuth('newStorageGoodsAddButton') && selfIsUse" type="primary" @click="goMaterielIntoWarehouse">商品入库</a-button>
                        <a-button v-else :disabled="true">商品入库</a-button>
                        <a-button v-if="getBtnByAuth('newStorageGoodsOutWarehouseButton') && selfIsUse" type="primary" @click="goMaterielOuttoWarehouse">商品出库</a-button>
                        <a-button v-else :disabled="true">商品出库</a-button>
                        <a-button v-if="getBtnByAuth('newStorageGoodsInventoryButton') && selfIsUse" type="primary" @click="goMaterielInventoryCheckIndex">库存盘点</a-button>
                        <a-button v-else :disabled="true">商品盘点</a-button>
                        <a-button v-if="getBtnByAuth('newStorageGoodsDeleteButton') && selfIsUse" type="primary" @click="goMaterielDelete">商品删除</a-button>
                        <a-button v-else :disabled="true">商品删除</a-button>
                    </div>
                </template>
                <a-tab-pane :key="0" >
                    <template slot="tab">
                        金蝶-库存数据 
                        {{kingDiskIsUse ? '（使用中）' : '（停用中）'}}
                        <a-tooltip placement="topLeft">
                            <template slot="title">
                                <span>每天00：00系统自动刷新数据，与金蝶系统数据进行对比同步</span>
                            </template>
                            <span class="text-primary">
                                <a-icon type="exclamation-circle" theme="filled" />
                            </span>
                        </a-tooltip>
                    </template>
                    <div class="wrap-container-in">
                        <div class="mb16" v-if="Number(shopId) === -1">
                            <span class="text-primary">当前所取金蝶系统机构为：{{shopBinding.organizationName || '请先选择切换并绑定机构！'}}</span>
                            <a class="ml16" @click="showSwitchOrganization">切换机构</a>
                        </div>
                        <a-table
                        :scroll="{y: 560}"
                        bordered
                        :dataSource="kingDeskData"
                        :columns="columns1"
                        :pagination="pagination1"
                        :rowKey="record => record.id"
                        :loading="kingDiskSearchLoading"
                        @change="kingDiskChangePage"
                        class="wrap-table"
                        >
                            <template slot="empty" slot-scope="key">
                                {{key !== null ? key : "-"}}
                            </template>
                            <template slot="actions" slot-scope="a,row">
                                <a v-if="getBtnByAuth('kingDiskGoodsDetailButton')" class="text-primary" @click="goDetail(row.id, 3)">库存详情</a>
                                <span v-else class="text-disabled">库存详情</span>
                            </template>
                        </a-table>
                    </div>
                </a-tab-pane>
                <!-- <a-tab-pane :key="1">
                    <template slot="tab">
                        系统自有-库存数据
                        {{selfIsUse ? '（使用中）' : '（停用中）'}}
                    </template>
                    <div class="wrap-container-in">
                        <a-table
                        bordered
                        :dataSource="selfData"
                        :columns="columns2"
                        :pagination="pagination2"
                        :rowKey="record => record.id"
                        :loading="selfSearchLoading"
                        @change="selfChangePage"
                        class="wrap-table"
                        >
                        <template slot="empty" slot-scope="key, row, index">
                            {{key !== null ? key : "-"}}
                        </template>
                        <template slot="useType" slot-scope="key, row, index">
                            {{['', '售卖', '自用'][key]}}
                        </template>
                        <template slot="actions" slot-scope="a,row">
                            <a v-if="getBtnByAuth('selfGoodsDetailButton')" class="text-primary" @click="goDetail(row.id, 2)">商品详情</a>
                            <span v-else class="text-disabled">商品详情</span>
                            <a-divider type="vertical"/>
                            <a v-if="getBtnByAuth('selfGoodsEditButton')" class="text-primary" @click="goMaterielEdit(row.id)">编辑</a>
                            <span v-else class="text-disabled">编辑</span>
                        </template>
                        </a-table>
                    </div>
                </a-tab-pane> -->
            </a-tabs>
            <a-modal
            centered
            :closable="false"
            :maskClosable="false"
            title="提示"
            :visible="visibleNoBasePriceTips"
            >
                <div>
                    <div class="font-big" v-if="Number(shopId) === -1">当前共有<span class="ml8 mr8 text-fail">{{remindData.count}}</span>个物料未进行默认售卖价报价</div>
                    <div class="font-big" v-else>当前共有<span class="ml8 mr8 text-fail">{{remindData.count}}</span>个物料为最新调拨，请设置售卖价</div>
                </div>
                <template slot="footer">
                    <a-button @click="visibleNoBasePriceTips = false">稍后处理</a-button>
                    <a-button type="primary" @click="goMaterielBatchRemind(true)">马上处理</a-button>
                </template>
            </a-modal>
            <a-modal
            centered
            title="切换确认"
            :width="500"
            :visible="visibleSwitchComfirm"
            @ok="switchOrganizationOk"
            @cancel="switchOrganizationCancel"
            :confirmLoading="switchOrganizationLoading"
            :destroyOnClose="true"
            :maskClosable="false"
            >
                <a-form :form="switchOrganizationForm" layout="inline">
                    <div class="mb16 text-primary">
                        当前所取金蝶系统机构为：{{shopBinding.organizationName}}
                    </div>
                    <a-form-item label="请选择金蝶系统对应机构">
                        <a-select 
                        style="width: 250px;" 
                        placeholder="请选择" 
                        :options="kingDiskOrganizationList" 
                        v-decorator="['organizationId', {rules: [{required: true, message: '请选择'}]}]"
                        ></a-select>
                    </a-form-item>
                </a-form>
            </a-modal>
            <a-modal
            centered
            :visible="visibleSyncing"
            :closable="false"
            :maskClosable="false"
            :footer="null"
            :width="300"
            >
                <div class="text-center text-primary">
                    <a-icon type="sync" class="animated rotate360 infinite slow" style="font-size: 36px;" />
                    <div class="mt24">数据刷新中，请稍等...</div>
                </div>
            </a-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    const columns1 = [
        {
            title: '物料编码',
            dataIndex: 'goodsNo',
        },
        {
            title: '物料条形码',
            dataIndex: 'goodsBarCode',
            scopedSlots: { customRender: 'empty' }

        },
        {
            title: '物料名称',
            dataIndex: 'goodsName'
        },
        {
            title: '所在仓库名称',
            dataIndex: 'warehouseName'
        },
        {
            title: '批号',
            dataIndex: 'lotName',
            scopedSlots: { customRender: 'empty' }
        },
        {
            title: '基本单位',
            dataIndex: 'goodsUnit'
        },
        {
            title: '物料分组',
            dataIndex: 'goodsGroup'
        },
        {
            title: '物料属性',
            dataIndex: 'goodsType'
        },
        {
            title: '库存数量',
            dataIndex: 'baseQty'
        },
        {
            title: '可用数量',
            dataIndex: 'baseAvbQty'
        },
        {
            title: '库存状态',
            dataIndex: 'warehouseStatus'
        },
        {
            title: '默认售卖价',
            dataIndex: 'basePrice',
            scopedSlots: { customRender: 'empty' }
        },
        {
            title: '实际售卖价',
            dataIndex: 'price',
            scopedSlots: { customRender: 'empty' }
        },
        {
            title: '操作',
            scopedSlots: { customRender: 'actions' }
        }
    ];
    const columns2 = [
        {
            title: '商品编号',
            dataIndex: 'goodsNo'
        },
        {
            title: '商品条形码',
            dataIndex: 'goodsBarCode',
            scopedSlots: { customRender: 'empty' }
        },
        {
            title: '商品名称',
            dataIndex: 'goodsName'
        },
        {
            title: '所在仓库名称',
            dataIndex: 'warehouseName'
        },
        {
            title: '商品规格',
            dataIndex: 'goodsSpecification'
        },
        {
            title: '基本单位',
            dataIndex: 'goodsUnit'
        },
        {
            title: '商品分组',
            dataIndex: 'categoryName'
        },
        {
            title: '使用类型',
            dataIndex: 'useType',
            scopedSlots: { customRender: 'useType'}
        },
        {
            title: '库存数量',
            dataIndex: 'currentInventory'
        },
        {
            title: '可用数量',
            dataIndex: 'availableInventory'
        },
        {
            title: '商品售卖价',
            dataIndex: 'sellPrice'
        },
        {
            title: '操作',
            scopedSlots: { customRender: 'actions' }
        }
    ];
    export default {
        name: 'materielManage',
        components: {},
        props: {},
        data() {
            return {
                columns1,
                columns2,
                typeOptions: [],
                kingDeskData: [],
                selfData: [],
                kingDiskOrganizationList: [],//金蝶机构数据
                shopBinding: {},//获取门店绑定的机构
                visibleSwitchComfirm: false,
                switchOrganizationLoading: false,
                kingDiskSearchLoading: false,
                selfSearchLoading: false,
                visibleNoBasePriceTips: false,
                kingDiskGoodsRefreshLoading: false,
                tabKey: 0,
                pagination1: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                pagination2: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                remindData: {},
                basePrice: 0,
                kingDiskIsUse: false,
                selfIsUse: false,
                visibleSyncing: false
            };
        },
        watch: {
            '$route'(val) {
                if(val.name == 'materielManage') {
                    this.getKingDiskGoodsList();
                    this.getSelfGoodsList();
                }
            },
            'shopId'() {
                this.pagination1.current = 1;
                this.pagination2.current = 1;
                this.getKingDiskGoodsList();
                this.getGoodsCateList();
                this.getSelfGoodsList();
                this.getShopBinding();
                this.getkingDiskOrganization();
                if (this.shopId != -1) {
                    this.getKingDiskGoodsShopRemind();
                }
                this.sysIsUse(0);
                this.sysIsUse(1);
            }
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            kingDiskChangePage(page) {
                this.pagination1 = page;
                this.getKingDiskGoodsList();
            },
            // 重置筛选
            kingDiskHandleReset() {
                this.filterForm1.resetFields();
                this.kingDiskSearch();
            },
            kingDiskSearch() {
                this.pagination1.current = 1;
                this.getKingDiskGoodsList();
            },
            /**
             * @getkingDiskOrganization 获取组织列表
             */
            getkingDiskOrganization() {
                if(!this.shopId) return
                this.$api.newStorage.kingDiskOrganization({}).then(res => {
                    res.forEach(item => {
                        item.value = item.id;
                        item.label = item.organizationName;
                    });
                    this.kingDiskOrganizationList = res;
                });
            },
            /**
             * @getShopBinding 获取门店绑定的机构
             */
            getShopBinding() {
                if(!this.shopId) return
                this.$api.newStorage.shopBinding({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (Boolean(res)) {
                        this.shopBinding = res;
                    }
                });
            },
            /**
             * @showSwitchOrganization 显示切换组织
             */
            showSwitchOrganization() {
                this.visibleSwitchComfirm = true;
            },
            /**
             * @switchOrganizationOk 切换组织确认
             */
            switchOrganizationOk() {
                this.switchOrganizationForm.validateFields((errors, values) => {
                    if (Boolean(errors)) return;
                    this.switchOrganizationLoading = true;
                    this.$api.newStorage.binding({
                        body: {
                            organizationId: values.organizationId,
                            shopId: this.shopId,
                            type: Boolean(this.shopId) === -1 ? 0 : undefined
                        }
                    }).then(res => {
                        this.switchOrganizationLoading = false;
                        this.visibleSwitchComfirm = false;
                        setTimeout(() => {
                            this.getShopBinding();
                            this.getKingDiskGoodsList();
                        }, 300);
                    }).catch(err => {
                        this.switchOrganizationLoading = false;
                    });
                });
            },
            /**
             * @switchOrganizationCancel 切换组织取消
             */
            switchOrganizationCancel() {
                this.visibleSwitchComfirm = false;
            },
            /**
             * @goMaterielIntoWarehouse 跳转商品入库
             */
            goMaterielIntoWarehouse() {
                this.$router.push({name: 'materielIntoWarehouse'});
            },
            /**
             * @goMaterielOuttoWarehouse 跳转商品出库
             */
            goMaterielOuttoWarehouse() {
                this.$router.push({name: 'materielOuttoWarehouse'});
            },
            /**
             * @goMaterielInventoryCheckIndex 跳转商品盘点
             */
            goMaterielInventoryCheckIndex() {
                this.$router.push({name: 'materielInventoryCheckIndex'});
            },
            /**
             * @goMaterielDelete 跳转商品删除
             */
            goMaterielDelete() {
                this.$router.push({name: 'materielDeleteIndex'});
            },
            /**
             * @goMaterielEdit 跳转新增
             */
            goMaterielEdit(id) {
                this.$router.push({name: 'materielEdit', params: {id}});
            },
            /**
             * @goDetail 跳转详情
             */
            goDetail(id, sysType) {
                this.$router.push({name: 'materielDetail', params: {id, sysType}});
            },
            /**
             * @getKingDiskGoodsList 获取物料详情
             */
            getKingDiskGoodsList() {
                if (this.kingDiskSearchLoading || !this.shopId) {
                    return false;
                }
                this.filterForm1.validateFields((errors, values) => {
                    if (errors) return;
                    this.kingDiskSearchLoading = true;
                    this.$api.newStorage.kingDiskGoodsList({
                        body: {
                            ...values,
                            pageNum: this.pagination1.current,
                            pageSize: this.pagination1.pageSize,
                            shopId: this.shopId
                        }
                    }).then(res => {
                        this.kingDiskSearchLoading = false;
                        if (Boolean(res) && Boolean(res.data)) {
                            this.kingDeskData = res.data;
                        }
                        this.pagination1.total = res.total;
                    }).catch(err => {
                        this.kingDiskSearchLoading = false;
                    });
                })
            },
            /**
             * @getKingDiskGoodsRemind 获取未进行默认售卖价报价提示（总店）
             */
            getKingDiskGoodsRemind() {
                if (!this.shopId || this.$route.name !== 'materielManage') {
                    return false;
                }
                this.$api.newStorage.kingDiskGoodsRemind({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (res.count > 0) {
                        this.remindData = res;
                        this.visibleNoBasePriceTips = true;
                    }
                });
            },
            /**
             * @getKingDiskGoodsShopRemind 获取未进行默认售卖价报价提示（门店）
             */
            getKingDiskGoodsShopRemind() {
                return false;
                if (!this.shopId || this.$route.name !== 'materielManage') {
                    return false;
                }
                this.$api.newStorage.kingDiskGoodsShopRemind({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (res.count > 0) {
                        this.remindData = res;
                        this.visibleNoBasePriceTips = true;
                    }
                });
            },
            /**
             * @kingDiskRemindUpdate 批量修改物料报价
             */
            kingDiskRemindUpdate(id) {
                this.$api.newStorage.kingDiskRemindUpdate({
                    body: {
                        infoList: [
                            {
                                id,
                                price: this.basePrice
                            }
                        ],
                        shopId: this.shopId
                    }
                }).then(res => {
                    this.$message.success('操作成功！');
                    this.basePrice = 0;
                    this.getKingDiskGoodsList();
                }).catch(err => {
                    this.basePrice = 0;
                });
            },
            /**
             * @kingDiskRemindUpdateCancel 取消批量修改物料报价
             */
            kingDiskRemindUpdateCancel() {
                this.basePrice = 0;
            },
            /**
             * @kingDiskGoodsRefresh 金蝶物料数据刷新
             */
            kingDiskGoodsRefresh() {
                this.visibleSyncing = true;
                this.kingDiskGoodsRefreshLoading = true;
                this.$api.newStorage.kingDiskGoodsRefresh({
                    body: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    this.visibleSyncing = false;
                    this.$message.success('数据刷新成功！', 5);
                    this.kingDiskGoodsRefreshLoading = false;
                    this.getKingDiskGoodsList();
                    if (this.shopId != -1) {
                        this.getKingDiskGoodsShopRemind();
                    }
                }).catch(err => {
                    this.visibleSyncing = false;
                    this.kingDiskGoodsRefreshLoading = false;
                });
            },
            // 自有系统
            selfChangePage(page) {
                this.pagination2 = page;
                this.getSelfGoodsList();
            },
            // 重置筛选
            selfHandleReset() {
                this.filterForm2.resetFields();
                this.selfSearch();
            },
            selfSearch() {
                this.pagination2.current = 1;
                this.getSelfGoodsList();
            },
            /**
             * @getSelfGoodsList 获取自有物料列表
             */
            getSelfGoodsList() {
                if (this.selfSearchLoading || !this.shopId) {
                    return false;
                }
                this.filterForm2.validateFields((errors, values) => {
                    if (errors) return;
                    this.selfSearchLoading = true;
                    this.$api.newStorage.selfGoodsPage({
                        body: {
                            ...values,
                            pageNum: this.pagination2.current,
                            pageSize: this.pagination2.pageSize,
                            shopId: this.shopId
                        }
                    }).then(res => {
                        this.selfSearchLoading = false;
                        if(Boolean(res) && Boolean(res.data)) {
                            this.selfData = res.data;
                            this.pagination2.total = res.total;
                        }
                    }).catch(err => {
                        this.selfSearchLoading = false;
                    });
                });
            },
            /**
             * @getGoodsCateList 获取商品类别
             */
            getGoodsCateList() {
                this.$api.newStorage.getSelfGoodsCateList({
                    query: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    if (Boolean(res)) {
                        res.forEach(item => {
                            item.label = item.categoryName;
                            item.value = item.id;
                        });
                        this.typeOptions = res;
                    }
                });
            },
            /**
             * @sysIsUse 是否使用该系统
             */
            sysIsUse(systemType) {
                if (!this.shopId) {
                    return false;
                }
                this.$api.newStorage.sysIsUse({
                    query: {
                        shopId: this.shopId,
                        systemType
                    }
                }).then(res => {
                    if (systemType === 0) {
                        this.kingDiskIsUse = Boolean(res.isUse);
                    } else {
                        this.selfIsUse = Boolean(res.isUse);
                    }
                });
            },
            /**
             * @goMaterielBatchRemind 跳转批量报价
             */
            goMaterielBatchRemind(isModal) {
                if (isModal) {
                    this.visibleNoBasePriceTips = false;
                    setTimeout(() => {
                        this.$router.push({name: 'materielRemind'});
                    }, 300);
                } else {
                    this.$router.push({name: 'materielRemind'});
                }
            }
        },
        beforeCreate() {
            this.filterForm1 = this.$form.createForm(this);
            this.filterForm2 = this.$form.createForm(this);
            this.switchOrganizationForm = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getKingDiskGoodsList();
            this.getGoodsCateList();
            this.getSelfGoodsList();
            this.getShopBinding();
            this.getkingDiskOrganization();
            if (this.shopId != -1) {
                this.getKingDiskGoodsShopRemind();
            }
            this.sysIsUse(0);
            this.sysIsUse(1);
        },
    };
</script>
<style lang="scss">
.wrap-container-in {
    background-color: #fff;
    padding: 24px 32px;
    border-radius: 2px;
}
.tabs-bar-no-margin {
    .ant-tabs-top-bar {
        margin: 0!important;
    }
}
</style>
